import React from 'react'

import PixiObject from 'common/builder/components/chart/FlowChart/pixi-object'

type PixiObjectWrapperProps<C extends React.ComponentType<React.ComponentProps<C>>> = Omit<
  React.ComponentProps<C>,
  'container'
> & {
  component: C
  pixiWidth: number
}

class Component<C extends React.ComponentType<React.ComponentProps<C>>> extends PixiObject {
  constructor(props: PixiObjectWrapperProps<C>) {
    super(props)
  }

  declare props: PixiObjectWrapperProps<C>
}

/**
 * Universal component PixiObject wrapper for node components
 */
export class PixiObjectNodeWrapper<
  C extends React.ComponentType<React.ComponentProps<C>>,
> extends Component<C> {
  reactPIXIGetWidth() {
    return this.props.pixiWidth
  }

  reactPIXIRender() {
    const root = this.obj
    const { component: Component, ...rest } = this.props

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    return <Component {...rest} container={root} />
  }

  useReactPIXIRenderer() {
    return true
  }
}
